<template>
    <Head title="Journeys" />
    <BaseLayout gap="sm">
        <JourneysHeader />
        <ManagerBanner v-if="isManager === null" @confirmed="handleManagerConfirmed" />
        <GoalsSection :is-manager="isManager" :suggested-resources-enabled="suggested_resources_enabled" />
    </BaseLayout>
</template>

<script lang="ts">
import LeftSidebarLayout from "~vue/layouts/LeftSidebarLayout.vue";
export default { layout: LeftSidebarLayout };
</script>

<script setup lang="ts">
import { Head } from "@inertiajs/vue3";
import { useFetch } from "~vue/api";
import { type DismissNotificationRequest } from "~vue/api/generated/navigation/types.gen";
import { dismissNotificationLocallyKey } from "~vue/appTypes";
import BaseLayout from "~vue/components/BaseLayout.vue";
import { MainMenuPane } from "~vue/components/navigation/menuPanes";
import GoalsSection from "~vue/pages/Journeys/GoalsSection.vue";
import { inject, onMounted, ref } from "vue";

import JourneysHeader from "./Journeys/JourneysHeader.vue";
import ManagerBanner from "./Journeys/ManagerBanner.vue";
import { JourneysAmplitudeEventNames, logJourneysUserInteraction } from "./Journeys/utils";

const props = defineProps<{ is_manager: boolean | null; suggested_resources_enabled: boolean }>();

const isManager = ref<boolean | null>(props.is_manager);

function handleManagerConfirmed(value: boolean) {
    isManager.value = value;
}

const dismissNotificationLocally = inject(dismissNotificationLocallyKey, () => {});

const recordVisitPayload: DismissNotificationRequest = { pane: "journeys", track_all_visits: true };
const { execute: recordVisit } = useFetch("/v1/navigation/notifications/dismiss", { immediate: false }).post(recordVisitPayload).json();

onMounted(async () => {
    dismissNotificationLocally(MainMenuPane.JOURNEYS);
    logJourneysUserInteraction(JourneysAmplitudeEventNames.PAGE_VIEWED, {
        is_manager: props.is_manager,
    });
    recordVisit();
});
</script>
